module.exports = __webpack_public_path__ + "static/media/dust2youtube.1eb23ec9.jpg";